import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@shared/services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const _authService = inject(AuthService);
  const userInfo = _authService.getCurrentUserInfo();

  if (userInfo?.sIdToken) {
    return true;
  } else {
    _authService.sendToAuthManager();
    return false;
  }
};
